import moment from "moment"

export const columns = [

    {
        Header:"Encaminhamento",
        align:"left",
        getValue : (row)=>{
            return row.encaminhamentoEntidade.nome 
        }
    },
    {
        Header:"Data",
        align:"left",
        getValue : (row)=>{
            return moment(row.dataHoraEmissao).format("DD/MM/YYYY")
        }
    },
    {
        Header:"Paciente",
        align:"left",
        getValue : (row)=>{
            return row.sujeitoAtencao.nome
        }
    },
    {
        Header:"Documento",
        align:"left",
        getValue : (row)=>{
            return row.nome 
        }
    },
]

  